import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';

export const templateMaintenanceWindowFormPatchSpecifics = document.createElement('template');

templateMaintenanceWindowFormPatchSpecifics.innerHTML = `
  <style>${colorHelpersStyles}</style>
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="form-wrapper">

    <gz-form-field id="operation-targeted-labeled-content">
      <div class="flex-group">
        <gz-form-field id="scan-for-patches-form-field" class="mr-2">
          <gz-checkbox gz-form-input></gz-checkbox>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        <gz-form-field id="apply-patches-form-field">
          <gz-checkbox gz-form-input></gz-checkbox>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </gz-form-field>

    <div id="scan-dependent-container">

      <gz-form-field id="patch-scope-labeled-content" class="hidden">
        <div class="flex-group">
          <gz-form-field id="apply-patches-security-form-field" class="mr-2">
            <gz-checkbox gz-form-input></gz-checkbox>
            <gz-input-error></gz-input-error>
          </gz-form-field>
          <gz-form-field id="apply-patches-non-security-form-field">
            <gz-checkbox gz-form-input></gz-checkbox>
            <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>
        <div class="ml-2 manually-approved-scope-section">
          <gz-form-field id="apply-patches-manually-approved-form-field">
            <gz-checkbox gz-form-input></gz-checkbox>
            <gz-input-error></gz-input-error>
          </gz-form-field>
          <div class="manually-approved-content">
            <gz-text id="manually-approved-patches-info-text" fontsize="12" class="info-text"></gz-text>
            <gz-maintenance-window-manually-approved-patches-selector></gz-maintenance-window-manually-approved-patches-selector>
          </div>
        </div>
      </gz-form-field>

      <div id="patch-options-container">
        <div id="schedulers-container" class="hidden">

          <gz-title class="title" fontweight="500" fontsize="18" id="scheduling-options-title"></gz-title>

          <div class="run-on-system-changes-subsection">
            <gz-form-field id="run-on-system-changes-form-field">
              <gz-toggle gz-form-input></gz-toggle>
              <gz-input-error></gz-input-error>
            </gz-form-field>
          </div>
          <gz-title id="runOnSystemChangesText" fontsize="12" class="pt-1 info-text"></gz-title>
          <gz-form-field id="use-same-schedule-form-field">
            <gz-toggle gz-form-input></gz-toggle>
            <gz-input-error></gz-input-error>
          </gz-form-field>
          <gz-form-field id="use-fallback-schedule-form-field">
            <gz-toggle gz-form-input></gz-toggle>
            <gz-input-error></gz-input-error>
          </gz-form-field>

          <gz-info-box severity='warning' id='fallback-schedule-notice-container'></gz-info-box>

          <div id="single-schedule-container" class="hidden">
            <gz-maintenance-window-scheduler id="schedule-for-all"></gz-maintenance-window-scheduler>
            <gz-maintenance-window-simple-scheduler id="schedule-for-all-simple" class="hidden" disabled="true"></gz-maintenance-window-simple-scheduler>
          </div>

          <div id="individual-schedules-container" class="hidden">
            <div id="schedule-scanning-patches-container" class="hidden">
              <gz-maintenance-window-scheduler id="schedule-scanning-patches"></gz-maintenance-window-scheduler>
              <gz-maintenance-window-simple-scheduler id="schedule-scanning-patches-simple" class="hidden" disabled="true"></gz-maintenance-window-simple-scheduler>
            </div>

            <div id="schedule-applying-patches-security-container" class="hidden">
              <gz-maintenance-window-scheduler id="schedule-applying-patches-security" data-has-immediately="true"></gz-maintenance-window-scheduler>
              <gz-maintenance-window-simple-scheduler id="schedule-applying-patches-security-simple" class="hidden" disabled="true" data-has-immediately="true"></gz-maintenance-window-simple-scheduler>
            </div>

            <div id="schedule-applying-patches-non-security-container" class="hidden">
              <gz-maintenance-window-scheduler id="schedule-applying-patches-non-security" data-has-immediately="true"></gz-maintenance-window-scheduler>
              <gz-maintenance-window-simple-scheduler id="schedule-applying-patches-non-security-simple" class="hidden" disabled="true" data-has-immediately="true"></gz-maintenance-window-simple-scheduler>
            </div>
          </div>

          <gz-form-field id="if-missed-run-as-soon-as-possible-form-field" class="hidden">
            <gz-toggle gz-form-input></gz-toggle>
            <gz-input-error></gz-input-error>
          </gz-form-field>
        </div>

        <div id="reboot-preferences-container" class="form-section hidden">
          <gz-maintenance-window-reboot-options id="reboot-options"></gz-maintenance-window-reboot-options>
        </div>

        <div id="additional-patch-settings-container" class="hidden">
          <gz-title class="title" fontweight="500" fontsize="18" id="additional-patch-settings-title"></gz-title><br>
          <gz-title fontSize="11" fontWeight="600" class="subsection-title" id="specific-relays-title"/></gz-title><br>
          <gz-text fontSize="14" fontWeight="500" class="subsection-description" id="specific-relays-description"/></gz-text><br>
          <gz-labeled-content id="relay-patch-caching-servers-labeled-content" hasFormLabelWidth>
            <gz-relay-patch-caching-servers></gz-relay-patch-caching-servers>
          </gz-labeled-content>
          <gz-form-field id="use-vendor-websites-fallback-form-field">
            <gz-toggle gz-form-input stopEmitEvents></gz-toggle>
          </gz-form-field>
        </div>

        <div id="vendor-products-pairs-container" class="hidden">
          <gz-title fontSize="11" fontWeight="600" class="subsection-title" id="specific-vendors-products-title"/></gz-title><br>
          <gz-text fontSize="14" fontWeight="500" class="subsection-description" id="specific-vendors-products-description"/></gz-text>
          <br>
          <gz-labeled-content id="vendors-products-to-be-labeled-content" hasFormLabelWidth>
            <gz-form-field id="vendors-products-to-be-form-field">
              <gz-radio-group gz-form-input>
                <div class="flex-group">
                  <gz-radio id="vendors-products-to-be-options-first" value="1"></gz-radio>
                  <gz-radio id="vendors-products-to-be-options-second" value="2"></gz-radio>
                </div>
              </gz-radio-group>
              <gz-input-error></gz-input-error>
            </gz-form-field>
          </gz-labeled-content>
          <gz-labeled-content id="vendors-products-selector-labeled-content" hasFormLabelWidth>
            <gz-maintenance-window-patch-management-vendor-product-selector></gz-maintenance-window-patch-management-vendor-product-selector>
          </gz-labeled-content>
        </div>
      </div>

    </div>
  </div>
`;
